import { createSlice } from "@reduxjs/toolkit";

/**
 * Account Slice — MangoTV
 * Pattern: mirrors glotv accountSlice.js
 *
 * Stores profile data, devices, messages, FAQs, and purchase history.
 */

const initialState = {
  profile: {
    first_name: "",
    last_name: "",
    email: "",
    username: "",
    date_of_birth: "",
  },
  devices: [],
  messages: [],
  FAQs: [],
  purchases: [],
  isProfileLoaded: false,
};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setProfile: (state, action) => {
      state.profile = { ...state.profile, ...action.payload };
      state.isProfileLoaded = true;
    },
    setDevices: (state, action) => {
      state.devices = action.payload;
    },
    removeDevice: (state, action) => {
      state.devices = state.devices.filter(
        (device) => device.id !== action.payload
      );
    },
    setMessages: (state, action) => {
      state.messages = action.payload;
    },
    setFAQs: (state, action) => {
      state.FAQs = action.payload;
    },
    setPurchases: (state, action) => {
      state.purchases = action.payload;
    },
    resetAccount: () => initialState,
  },
});

export const {
  setProfile,
  setDevices,
  removeDevice,
  setMessages,
  setFAQs,
  setPurchases,
  resetAccount,
} = accountSlice.actions;

export default accountSlice.reducer;
